var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '../../../Typography';
import { MenuTestIdFactory } from '../../interactions';
import styles from './MenuGroupTitle.module.css';
export const MenuGroupTitle = ({ children, 'data-testid': testid, Icon, }) => (_jsxs("div", { className: styles.Container, "data-testid": MenuTestIdFactory.getMenuGroupTitleTestId(testid), children: [Icon && _jsx(Icon, { className: styles.Icon, size: "small" }), _jsx(Typography, { color: "accent", "data-testid": MenuTestIdFactory.getMenuGroupTitleTextTestId(testid), fontWeight: "bold", kind: "subtitle", uppercase: true, children: children })] }));
_react_refresh_temp_1 = MenuGroupTitle;
$RefreshReg$(_react_refresh_temp_1, "MenuGroupTitle");
